import BaseLayout from '../base/base_layout';
import Model from './loggedin_cashier_only_layout_model';
import ServiceFactory from '../../../../services/service_factory';
import {CASHIER_ACTIONS} from "../../../external_links/external_links_consts";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";
let loggedin = require('./view/cashier-container.html');


class LoggedinCashierOnlyLayout extends BaseLayout {
    /**
     * @static
     * @type {string}
     */
    static layoutName = 'cashier_only';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init();

        if (params) {
            this._stepParent = params.stepParent;
        }

        this._model = Model.create(params);
    }


    /**
     *
     * @returns {LoggedinInlineLayout}
     */
    start() {
        let bakedHTML = this.bake(loggedin, {});
        this
            .setHTML(bakedHTML)
            ._onCashier(); // Should be after baked the html because we need to attach event to something that may not be appear.

        return this;
    }


    /**
     * Open cashier if exist.
     *
     * @private
     */
    _onCashier() {
        if (!this._model.getShowCashier()) {
            return this;
        }

        this.onChildElementEvent('.cgp-cashier', 'click', (event) => {
            event.preventDefault();
            this._sendAnalytics({action: 'Cashier'});
            // to force default behaviour uncomment getting view logic
            // let view = this._model.getCashierOpenType() === 0 ? 'iframe' : 'window';
            ServiceFactory.create().cashierProxyService().openCashier({
                sessionType: CASHIER_ACTIONS.FULL_CASHIER,
                channel: {
                    source: CHANNEL_SOURCE.casinoClient,
                    area: AreaType.InGame,
                    element: CHANNEL_ELEMENTS.depositButton
                }
            });
        });

        return this;
    }
}

export default LoggedinCashierOnlyLayout;
